import { call, put, takeLatest } from 'redux-saga/effects';

import { psmAuditDigital, notification } from '../../actionTypes';
import dataProvider from '../../store/dataProvider';
import { getNotificationErrorMessage } from './helpers';

function* followUpDelete({ payload: { auditFollowUpId } }) {
  try {
    yield call(dataProvider.deleteList, `audit/follow-up/${auditFollowUpId}`);
    yield put({ type: psmAuditDigital.followUpDelete.end, payload: { auditFollowUpId } });
    yield put({ type: notification.add, payload: { success: 'Follow-up deleted successfully' } });
  } catch (e) {
    yield put({ type: psmAuditDigital.followUpDelete.error, payload: { auditFollowUpId } });
    yield put({
      type: notification.add,
      payload: { error: getNotificationErrorMessage(e, 'Failed to delete follow-up') },
    });
  }
}

export default function* followUpDeleteSaga() {
  yield takeLatest(psmAuditDigital.followUpDelete.start, followUpDelete);
}
